// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Áthelyezve ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + ' művelet végrehajtva',
  accButtonProgressStatus: (p: { label: string }) => p['label'] + ' művelet folyamatban',
  accColorPalette: () => 'Színpaletta',
  accColorSwatch: () => 'Színminta',
  accCommandKey: () => 'Command',
  accContextMenuLabel: () => 'műveletek',
  accControlKey: () => 'Bezárás',
  accPositionAfter: () => 'utána',
  accPositionBefore: () => 'előtte',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Tartsa lenyomva a(z) ' +
    p['keyPressed'] +
    ' és a Shift billentyűt, majd használja a nyílbillentyűket az átrendezéshez.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Teljes dátumot adjon meg, például: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Adja meg a hónapot és az évet, például: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Címke',
  chart_labelGroup: () => 'Csoport',
  chart_labelSeries: () => 'Sorozat',
  chart_labelValue: () => 'Érték',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Jelöljön ki egy értéket.',
  checkbox_helpForCheckbox: () => 'Súgó jelölőnégyzethez',
  checkbox_requiredMessageDetail: () => 'Jelöljön ki egy értéket.',
  checkbox_selected: () => 'Jelölőnégyzet bejelölve',
  checkbox_unselected: () => 'Jelölőnégyzet nincs bejelölve',
  close: () => 'Bezárás',
  collection_apply: () => 'Alkalmaz',
  collection_cancel: () => 'Mégse',
  collection_loaded: () => 'Betöltve',
  collection_loading: () => 'Betöltés',
  collection_noData: () => 'Nincs megjeleníthető adat.',
  collection_pixels: () => 'képpont',
  collection_resizeColumnDialog: () => 'Oszlop átméretezése',
  collection_resizeColumnMenu: () => 'Oszlop átméretezése...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    p['MIN'] + ' és ' + p['MAX'] + ' közötti számot adjon meg.',
  collection_selectAllRows: () => 'Minden sor kijelölése',
  collection_selectRow: (p: { ROW_NAME: string }) => p['ROW_NAME'] + '. sor kijelölése',
  collection_sortAscendingSubMenu: () => 'Növekvő',
  collection_sortColumnMenu: () => 'Oszlopok rendezése',
  collection_sortDescendingSubMenu: () => 'Csökkenő',
  collection_sortDisabled: () => 'Nem rendezhető',
  collection_sortEnabled: () => 'Rendezhető',
  collection_width: () => 'Szélesség',
  colorPicker_label: () => 'Színválasztó',
  confirmation: () => 'Megerősítés',
  datePicker_currentDate: () => 'Aktuális dátum',
  datePicker_goToToday: () => 'Ugrás a mai napra',
  datePicker_label: () => 'Dátumválasztó',
  datePicker_month: () => 'Hónap',
  datePicker_months: () => 'Hónapok',
  datePicker_next: () => 'Tovább',
  datePicker_nextDecade: () => 'Következő évtized',
  datePicker_nextMonth: () => 'Következő hónap',
  datePicker_prev: () => 'Vissza',
  datePicker_prevDecade: () => 'Előző évtized',
  datePicker_prevMonth: () => 'Előző hónap',
  datePicker_restricted: () => 'Korlátozott',
  datePicker_selected: () => 'Kijelölt',
  datePicker_today: () => 'Ma',
  datePicker_weekNum: (p: { NUM: string }) => p['NUM'] + '. hét',
  datePicker_weekNumColLabel: () => 'Hét száma',
  datePicker_year: () => 'Év',
  datePicker_years: () => 'Évek',
  diagram_promotedLink: () => '1 hivatkozás',
  diagram_promotedLinkAriaDesc: () => 'Közvetett',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' hivatkozás',
  error: () => 'Hiba',
  expandableList_expandCollapseInstructionText: () =>
    'A kibontáshoz és összecsukáshoz használja a nyílbillentyűket',
  expandableList_groupCollapse: () => 'Összecsukott',
  expandableList_groupExpand: () => 'Kibontott',
  filePicker_addFiles: () => 'Fájlok hozzáadása',
  filePicker_dropzonePrimaryText: () => 'Áthelyezés húzással',
  filePicker_dropzoneSecondaryText: () => 'Válassza ki a fájlt, vagy húzza át ide',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Válassza ki a fájlokat, vagy húzza át ide',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nem tölthet fel ' + p['fileTypes'] + ' típusú fájlt',
  filePicker_singleFileUploadError: () => 'Egyszerre csak egy fájlt töltsön fel',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nem tölthet fel ' + p['fileType'] + ' típusú fájlt',
  filePicker_unknownFileTypeUploadError: () => 'ismeretlen',
  formControl_clear: () => 'Törlés',
  formControl_day: () => 'Nap',
  formControl_empty_segment: () => 'Üres',
  formControl_helpAvailable: () => 'Elérhető súgó',
  formControl_hide: () => 'Elrejtés',
  formControl_hour: () => 'Óra',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Elérte a(z) ' +
    ((
      { one: new Intl.NumberFormat('hu').format(p['CHARACTER_LIMIT']) + ' karakteres' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('hu').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('hu').format(p['CHARACTER_LIMIT']) + ' karakteres') +
    ' korlátot.',
  formControl_loading: () => 'Betöltés',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Legfeljebb ' + p['MAX_LENGTH'] + ' karaktert adhat meg.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Túllépte a maximális hosszt: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' karakter maradt.',
  formControl_millisecond: () => 'Ezredmásodperc',
  formControl_minute: () => 'Perc',
  formControl_month: () => 'Hónap',
  formControl_readOnly: () => 'Írásvédett',
  formControl_requiredMessageDetail: () => 'Adjon meg egy értéket.',
  formControl_second: () => 'Másodperc',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Válasszon ' + p['n'] + ' értéket.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Elérte a választható értékek korlátját (' + p['max'] + ').',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Válasszon értéket ' + p['min'] + ' és ' + p['max'] + ' között.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Válasszon legalább ' + p['min'] + ' értéket.',
  formControl_show: () => 'Megjelenítés',
  formControl_year: () => 'Év',
  gantt_labelDate: () => 'Dátum',
  gantt_labelEnd: () => 'Befejezés',
  gantt_labelLabel: () => 'Címke',
  gantt_labelRow: () => 'Sor',
  gantt_labelStart: () => 'Kezdés',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nem található egyező szakasz.',
  indexer_keyboardInstructionText: () => 'Az érték kiválasztásához nyomja meg az Enter billentyűt.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + ' és ' + p['TO_SECTION'] + ' között.',
  indexer_touchInstructionText: () =>
    'A gesztus módba belépéshez dupla koppintás és megtartás, majd lefelé vagy felfelé húzás az érték beállításához.',
  info: () => 'Információ',
  inputColor_selectColor: () => 'Válasszon egy színt',
  inputDateMask_date_cleared: () => 'Dátum törölve',
  inputDateMask_dayPlaceholder: () => 'nn',
  inputDateMask_empty_segment: () => 'Üres',
  inputDateMask_monthPlaceholder: () => 'hh',
  inputDateMask_yearPlaceholder: () => 'éééé',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Adjon meg a(z) ' + p['max'] + ' dátumnál nem későbbi dátumot.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Adjon meg a(z) ' + p['min'] + ' dátumnál nem korábbi dátumot.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Adjon meg egy elérhető dátumot.',
  inputDatePicker_instruction: () => 'A naptár eléréséhez nyomja meg a Tab billentyűt.',
  inputDatePicker_selectDate: () => 'Dátum kiválasztása',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Adjon meg a(z) ' + p['max'] + ' értéknél nem későbbi hónapot és évet.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Adjon meg a(z) ' + p['min'] + ' értéknél nem korábbi hónapot és évet.',
  inputNumber_converterParseError: () => 'Adjon meg egy számot.',
  inputNumber_decrease: () => 'Csökkentés',
  inputNumber_increase: () => 'Növelés',
  inputPassword_hidden: () => 'Jelszó elrejtve',
  inputPassword_hide: () => 'Jelszó elrejtése',
  inputPassword_show: () => 'Jelszó megjelenítése',
  inputSensitiveText_hidden: () => 'Bizalmas adatot tartalmazó szöveg elrejtve',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Adjon meg a(z) ' + p['max'] + ' időpontnál nem későbbi időpontot.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Adjon meg a(z) ' + p['min'] + ' időpontnál nem korábbi időpontot.',
  inputTimeMask_time_cleared: () => 'Idő törölve',
  labelNone: () => 'Nincs',
  list_msgFetchCompleted: () => 'Betöltve',
  list_msgFetchingData: () => 'Betöltés',
  list_suggestion: () => 'Javaslat',
  menu_stateLoading: () => 'Betöltés',
  messageToast_allMessagesClosed: () => 'Az összes információs üzenet bezárva.',
  message_close: () => 'Bezárás',
  message_confirmation: () => 'Siker',
  message_error: () => 'Hiba',
  message_info: () => 'Információ',
  message_navigationFromMessagesRegion: () =>
    'Belépés az üzenetek régióba. Az F6 billentyűvel navigálhat.',
  message_navigationToMessagesRegion: () =>
    'Az üzenetek régióban új üzenetek találhatók. Az F6 billentyűvel navigálhat.',
  message_navigationToTouch: () => 'Az üzenetek régióban új üzenetek találhatók.',
  message_warning: () => 'Figyelmeztetés',
  noData_message: () => 'Nincs megjeleníthető elem',
  overflowItemLabel: () => 'További lapok',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'A megnyitott előugró ablak bezárásához érintse meg duplán.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Belépés előugró ablakba. Az F6 billentyűvel válthat át az előugró ablak és a társított vezérlőelem között.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Előugró ablak megnyitva. Az F6 billentyűvel válthat át az előugró ablak és a társított vezérlőelem között.',
  progressIndeterminate: () => 'Folyamatban',
  radioButton_checked: () => 'Választógomb bejelölve',
  radioButton_selected: () => 'Választógomb kiválasztva',
  radioButton_unchecked: () => 'Választógomb nincs bejelölve',
  radioButton_unselected: () => 'Választógomb nincs kiválasztva',
  radio_helpForRadio: () => 'Súgó választógombhoz',
  radio_requiredMessageDetail: () => 'Jelöljön ki egy értéket.',
  selectMultiple_apply: () => 'Alkalmaz',
  selectMultiple_back: () => 'Vissza',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Az egyes értékek kiemeléséhez használja a balra és jobbra nyílbillentyűket.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'A kijelölt érték eltávolításához nyomja meg a Backspace vagy a Delete billentyűt.',
  selectMultiple_selectedValues: () => 'Kiválasztott értékek',
  selectMultiple_showSelectedValues: () => 'Csak a kijelölt értékek megjelenítése.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' kiválasztott érték.',
  select_addToList: () => 'Hozzáadás listához',
  select_addToListAvailable: () => 'Hozzáadás listához elérhető',
  select_closeDropdown: () => 'A bezáráshoz nyomja meg az Escape billentyűt.',
  select_moreSearchOptions: () => 'További keresési beállítások',
  select_moreSearchOptionsAvailable: () => 'További keresési beállítások elérhetők',
  select_noMatchesFound: () => 'Nincs találat.',
  select_oneMatchFound: () => 'Egy egyezés található',
  select_requiredMessageDetail: () => 'Jelöljön ki egy értéket.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' egyezés található',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' vagy több egyezés található',
  selectorAll_deselectAll: () => 'Összes kijelölés törlése',
  selectorAll_selectAll: () => 'Mindent kijelöl',
  selector_selected: () => 'Jelölőnégyzet bejelölve',
  selector_unselected: () => 'Jelölőnégyzet nincs bejelölve',
  sheet_close: () => 'Bezárás',
  switch_off: () => 'Ki',
  switch_on: () => 'Be',
  tabBarNavigationList_removeCueText: () => 'Eltávolítható',
  tabBar_tabContainsErrors: () => 'Hibákat tartalmaz',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Eltávolított ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'helyi menüvel rendelkezik',
  tabbar_labelMoveLeft: () => 'Áthelyezés balra',
  tabbar_labelMoveRight: () => 'Áthelyezés jobbra',
  tabbar_labelRemove: () => 'Eltávolítás',
  timeComponent_tooltipZoomIn: () => 'Nagyítás',
  timeComponent_tooltipZoomOut: () => 'Kicsinyítés',
  timeConverter_parseError: () => 'Adjon meg teljes időt.',
  train_current: () => 'Aktuális',
  train_message_type: () => 'Üzenet típusa',
  train_not_visited: () => 'Nem látogatott',
  train_status: (p: { numberOfSteps: string; currentStep: string }) =>
    p['numberOfSteps'] + '/' + p['currentStep'] + '. lépés',
  train_visited: () => 'Látogatott',
  userAssistance_learnMore: () => 'További tudnivalók',
  userAssistance_required: () => 'Kötelező',
  vis_clearSelection: () => 'Kijelölés megszüntetése',
  vis_drillable: () => 'Részletezhető',
  vis_invalidData: () => 'Érvénytelen adatok',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { totalCount: string; itemCount: string }) =>
    p['totalCount'] + '/' + p['itemCount'],
  vis_marqueeSelectTooltip: () => 'Futószöveg kijelölése',
  vis_marqueeZoomTooltip: () => 'Kijelölés nagyítása',
  vis_noData: () => 'Nincs megjeleníthető adat',
  vis_panTooltip: () => 'Eltolás',
  vis_stateCollapsed: () => 'Összecsukott',
  vis_stateExpanded: () => 'Kibontott',
  vis_stateLoaded: () => 'Betöltve',
  vis_stateLoading: () => 'Betöltés',
  vis_stateSelected: () => 'Kijelölt',
  vis_stateUnselected: () => 'Nem kijelölt',
  warn: () => 'Figyelmeztetés'
};
export default bundle;
